<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="640px"
    @keydown.esc.prevent="close()"
  >
    <el-overlay-loading :loading="saving" />
    <v-card>
      <v-card-title class="modalTitle pt-2 pb-1">
        <h3>{{ editId ? $t('Redaguoti taisyklę') : $t('Nauja taisyklė') }}</h3>
      </v-card-title>
      <v-card-text class="pt-2">
        <form @keydown.enter.prevent="submit()">
        <el-autocomplete
          class="mb-4"
          :items="fieldSelectItems"
          direct
          multiple
          itemvalue="value"
          itemtext="text"
          label="Laukai"
          v-model="selectedFieldIds"
          required
        />
        <el-text-field
          :label="$t('Reikalingų laukų skaičius')"
          v-model="form.required_count"
          type="text"
          cMask="10"
          required
        />
        <el-textarea
          class="mt-2"
          :label="$t('Klaidos pranešimas (LT)')"
          v-model="form.error_message_lt"
          :maxlength="2000"
          required
        />
        <el-textarea
          class="mt-2"
          :label="$t('Klaidos pranešimas (EN)')"
          v-model="form.error_message_en"
          :maxlength="2000"
          required
        />
        </form>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <el-button
          title="Atšaukti"
          color="secondary"
          @click.native.stop="close()"
          :loading="saving"
        />
        <el-button
          title="Išsaugoti"
          color="primary"
          icon="išsaugoti"
          @click.native.stop="submit()"
          :loading="saving"
        />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'ModalActionExtraFieldRule',
  $_veeValidate: {
    validator: 'new',
  },
  props: {
    value: Boolean,
    setId: {
      type: [Number, String],
      required: true,
    },
    fields: {
      type: Array,
      default: () => [],
    },
    rule: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      saving: false,
      selectedFieldIds: [],
      form: {
        required_count: 1,
        error_message_lt: '',
        error_message_en: '',
      },
      editId: null,
    }
  },
  computed: {
    dialog: {
      get() {
        return this.value
      },
      set(v) {
        this.$emit('input', v)
      },
    },
    fieldSelectItems() {
      return this.fields
        .filter((f) => f && f.id)
        .map((f) => ({
          value: Number(f.id),
          text: this.fieldItemLabel(f),
        }))
    },
    maxRequired() {
      const n = this.selectedFieldIds.length
      return n > 0 ? n : 1
    },
  },
  watch: {
    value(open) {
      if (open) {
        this.syncForm()
        this.$nextTick(() => {
          if (this.$validator) {
            this.$validator.reset()
          }
        })
      }
    },
    rule: {
      handler() {
        if (this.value) {
          this.syncForm()
        }
      },
      deep: true,
    },
  },
  methods: {
    fieldItemLabel(item) {
      const key = item.field_key || ''
      const lt = item.label_lt ? ` — ${item.label_lt}` : ''
      return `${key}${lt}`
    },
    syncForm() {
      if (this.rule && this.rule.id) {
        this.editId = this.rule.id
        const ids = this.rule.field_ids || []
        this.selectedFieldIds = ids.map((id) => Number(id))
        this.form = {
          required_count: Number(this.rule.required_count) || 1,
          error_message_lt: this.rule.error_message_lt || '',
          error_message_en: this.rule.error_message_en || '',
        }
      } else {
        this.editId = null
        this.selectedFieldIds = []
        this.form = {
          required_count: 1,
          error_message_lt: '',
          error_message_en: '',
        }
      }
    },
    close() {
      if (this.$validator) {
        this.$validator.reset()
      }
      this.dialog = false
    },
    submit() {
      this.$validator.validateAll().then((res) => {
        if (!res) {
          this.$root.$emit('FORMAT_ERROR')
          return
        }
        if (!this.selectedFieldIds.length) {
          this.$root.$emit(
            'DATA_ERROR_DIRECT_TEXT',
            this.$t('Pasirinkite bent vieną lauką')
          )
          return
        }
        const req = Number(this.form.required_count)
        if (req < 1 || req > this.selectedFieldIds.length) {
          this.$root.$emit(
            'DATA_ERROR_DIRECT_TEXT',
            this.$t(
              'Reikalingų laukų skaičius turi būti nuo 1 iki pasirinktų laukų kiekio'
            )
          )
          return
        }
        this.saving = true
        const payload = {
          id: this.editId,
          action_extra_field_set_id: Number(this.setId),
          field_ids: this.selectedFieldIds.map((id) => Number(id)),
          required_count: req,
          error_message_lt: this.form.error_message_lt || null,
          error_message_en: this.form.error_message_en || null,
        }
        this.$axios
          .post(`action-extra-field-rules`, payload)
          .then(() => {
            this.$root.$emit('DATA_OK_CODE', '000110')
            this.$emit('saved')
            this.close()
          })
          .catch((err) => {
            this.$root.$emit('DATA_ERROR', err)
          })
          .finally(() => {
            this.saving = false
          })
      })
    }
  },
}
</script>
